export default {
  setPlanData(state, plan) {
    state.plan = plan;
  }
}
